import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";

export default function FeedbackButton() {
  const [location, setLocation] = useLocation();

  const handleClick = () => {
    const returnUrl = encodeURIComponent(location);
    setLocation(`/feedback?returnUrl=${returnUrl}`);
  };

  return (
    <div className="fixed bottom-4 right-4 md:right-auto md:left-4 z-50">
      <Button
        onClick={handleClick}
        variant="default"
        size="sm"
        className="bg-primary text-primary-foreground rounded-full shadow-lg gap-2"
        data-testid="button-give-feedback"
      >
        <HelpCircle className="w-4 h-4" />
        <span className="hidden md:inline">Help & Feedback</span>
      </Button>
    </div>
  );
}
